module.exports = __webpack_public_path__ + "static/media/sub-card-label-11-over.9f018012.svg";